define('services/myreport/myreport-app-statistics-common.services',['app'], function (app) {
    app.factory('AppSurveyReport', ['OpenApp', 'OpenOther', 'auiDialog',
            function (OpenApp, OpenOther, auiDialog) {
                /**
                 *
                 * @param result
                 * @param showItem
                 * @returns *
                 */
                function initInstallConf(result, showItem, magicType) {
                    magicType = magicType || 'line';
                    var dataLegendAll = ['累计总安装', '日总安装', '日新增安装', '日更新安装'];
                    var seriesDataAll = [
                        {
                            "name": "累计总安装",
                            "type": magicType,
                            "yAxisIndex": 1,
                            "data": result["installTotal"]
                        }, {
                            "name": "日总安装",
                            "type": magicType,
                            "data": result["installTotalDay"]

                        }, {
                            "name": "日新增安装",
                            "type": magicType,
                            "data": result["appInstallNumDayTotal"]
                        }, {
                            "name": "日更新安装",
                            "type": magicType,
                            "data": result["updateDay"]

                        }];
                    var dataLegend = [];
                    var seriesData = [];
                    var key = 0;
                    for (var index in showItem) {
                        if (showItem[index] == 1) {
                            dataLegend[key] = dataLegendAll[index];
                            seriesData[key] = seriesDataAll[index];
                            key++;
                        }
                    }
                    return key == 0 ? null : {
                        legend: {
                            data: dataLegend
                        },
                        xAxis: [{ // 横坐标
                            type: 'category', data: result["dateTime"]
                        }],
                        yAxis: [{ // 纵坐标
                            position: 'left',
                            name: '安装数量(次)',
                            type: 'value'
                        }, { // 纵坐标
                            position: 'right',
                            name: '累计总安装量(次)',
                            type: 'value'
                        }],
                        series: seriesData
                    };
                }

                function initActivationConf(result, showItem, magicType) {
                    magicType = magicType || 'line';
                    var dataLegendAll = ['新增激活', '累计激活'];
                    var seriesDataAll = [{
                        "name": "新增激活",
                        "type": magicType,
                        "data": result["activationDay"]
                    }, {
                        "name": "累计激活",
                        "type": magicType,
                        "yAxisIndex": 1,
                        "data": result["activationTotal"]
                    }];
                    var seriesData = [];
                    var dataLegends = [];
                    var key = 0;
                    for (var index in showItem) {
                        if (showItem[index] == 1) {
                            seriesData[key] = seriesDataAll[index];
                            dataLegends[key] = dataLegendAll[index];
                            key++;
                        }
                    }
                    return key == 0 ? null : {
                        legend: {
                            data: dataLegends
                        },
                        xAxis: [{ // 横坐标
                            type: 'category', data: result["dateTime"]
                        }],
                        yAxis: [{ // 纵坐标
                            position: 'left',
                            name: '新增激活(次)',
                            type: 'value'
                        }, { // 纵坐标
                            position: 'right',
                            name: '累计激活(次)',
                            type: 'value'
                        }],
                        series: seriesData
                    };
                }

                function initActiveConf(result, showItem, magicType) {
                    magicType = magicType || 'line';
                    return {
                        legend: {
                            data: ['日活']
                        },
                        xAxis: [{ // 横坐标
                            type: 'category', data: result["dateTime"]
                        }],
                        yAxis: [{ // 纵坐标
                            type: 'value'
                        }],
                        series: [{
                            "name": "日活",
                            "type": magicType,
                            "data": result["activeDay"]
                        }]
                    };
                }


                function initActivateConf(result, showItem, magicType) {
                    magicType = magicType || 'line';
                    var itemStyle = {
                        "itemStyle": {
                            "barWidth": 20,
                            "normal": {
                                "label": {
                                    "show": true,
                                    "position": "inside"
                                }
                            }
                        }
                    };
                    return magicType != 'bar' ? {
                        legend: {
                            data: ['忠诚用户', '连续4周活跃用户', '连续3周活跃用户', '连续2周活跃用户', '1周内活跃用户']
                        },
                        "series": [
                            {
                                "name": "忠诚用户",
                                "type": magicType,
                                "stack": "总数",
                                "data": result["type5"]
                            },
                            {
                                "name": "连续4周活跃用户",
                                "type": magicType,
                                "stack": "总数",
                                "data": result["type4"]
                            },
                            {
                                "name": "连续3周活跃用户",
                                "type": magicType,
                                "stack": "总数",
                                "data": result["type3"]
                            },
                            {
                                "name": "连续2周活跃用户",
                                "type": magicType,
                                "stack": "总数",
                                "data": result["type2"]
                            },
                            {
                                "name": "1周内活跃用户",
                                "type": magicType,
                                "stack": "总数",
                                "data": result["type1"]
                            }
                        ],
                        "xAxis": [
                            {
                                type: 'category', data: result["dateTime"]
                            }
                        ],
                        "yAxis": [
                            {
                                "type": "value"
                            }
                        ]
                    } : {
                        legend: {
                            data: ['忠诚用户', '连续4周活跃用户', '连续3周活跃用户', '连续2周活跃用户', '1周内活跃用户']
                        },
                        "series": [
                            {
                                "name": "忠诚用户",
                                "type": 'bar',
                                "itemStyle": itemStyle,
                                "stack": "总数",
                                "data": result["type5"]
                            },
                            {
                                "name": "连续4周活跃用户",
                                "type": 'bar',
                                "itemStyle": itemStyle,
                                "stack": "总数",
                                "data": result["type4"]
                            },
                            {
                                "name": "连续3周活跃用户",
                                "type": 'bar',
                                "itemStyle": itemStyle,
                                "stack": "总数",
                                "data": result["type3"]
                            },
                            {
                                "name": "连续2周活跃用户",
                                "type": 'bar',
                                "itemStyle": itemStyle,
                                "stack": "总数",
                                "data": result["type2"]
                            },
                            {
                                "name": "1周内活跃用户",
                                "type": 'bar',
                                "itemStyle": itemStyle,
                                "stack": "总数 ",
                                "data": result["type1"]
                            }

                        ],
                        "yAxis": [{"type": "value"}],
                        "xAxis": [{type: 'category', data: result["dateTime"]}
                        ]
                    };
                }

                /**
                 * 获取日期X轴（参考report_analysis_activate.js原有的方法）
                 *
                 * @param dataArray 【20170315-20170323】
                 * @returns Array
                 */
                function getXAxis(dataList, key) {
                    for (var data in dataList) {
                        var sun = dataList[data][key].substr(9);
                        //年
                        var sunYear = sun.substring(0, 4);
                        //月
                        var sunMonth = sun.substring(4, 6);
                        //日
                        var sunDay = sun.substring(6);
                        sun = sunYear + "-" + sunMonth + "-" + sunDay;
                        dataList[data]['dateTime'] = sun;
                    }
                    return dataList;
                }

                /**
                 * 计算增长率（直接复制report_analysis.js原有的方法）
                 * @param dividend
                 * @param divider
                 * @param pointSize
                 * @param hundred
                 * @returns string
                 */
                function ration(dividend, divider, pointSize, hundred) {
                    var ret = "";
                    dividend = parseFloat(dividend);
                    divider = parseFloat(divider);
                    pointSize = pointSize ? pointSize : 2;
                    if (divider == 0) {
                        ret = 0;
                    }
                    else {
                        ret = dividend /
                            divider *
                            100;
                    }
                    ret = ret.toFixed(pointSize);
                    if (ret > 0) {
                        ret = "+" + ret
                    }
                    if (hundred) {
                        ret += "%";
                    }
                    return ret;
                }

                /**
                 * 查询条件要求传递【前天~昨天】
                 */
                function getQuerySumDate() {
                    var startDate = new Date();
                    var endDate = new Date();
                    var y = startDate.getFullYear();
                    var m = startDate.getMonth();
                    var d = startDate.getDate();
                    startDate.setFullYear(y, m, d - 2);
                    endDate.setFullYear(y, m, d - 1);
                    return {startDate: dateToString(startDate), endDate: dateToString(endDate)};
                }

                /**
                 *
                 * @param date
                 * @returns {*}
                 */
                function dateToString(date) {
                    if (angular.isDate(date)) {
                        var mm = (date.getMonth() + 1).toString(); // 开始时间格式规则
                        if (mm.length != 2) {
                            mm = 0 + (date.getMonth() + 1).toString();
                        }
                        var dd = date.getDate().toString();
                        if (dd.length != 2) {
                            dd = 0 + date.getDate().toString();
                        }
                        var str = date.getFullYear().toString() + "-" + mm + "-" + dd;
                        return str;
                    }
                    return date;
                }

                /**
                 *
                 * @param startTime
                 * @param endTime
                 * @param dateNum
                 * @returns {boolean}
                 */
                function checkQueryDate(startTime, endTime, dateNum) {
                    startTime = dateToString(startTime);
                    endTime = dateToString(endTime);

                    if (!startTime || !endTime) {
                        auiDialog.fail('请选择正确的时间。');
                        return false;
                    }
                    if (AUI.DateUtil.calDaysDual(endTime, startTime) < 1) {
                        auiDialog.fail('结束日期不能小于开始日期。');
                        return false;
                    }
                    if (AUI.DateUtil.calDaysDual(startTime, dateToString(new Date())) > 1) {
                        auiDialog.fail('开始日期不能大于今天。');
                        return false;
                    }
                    if (AUI.DateUtil.calDaysDual(endTime, dateToString(new Date())) > 1) {
                        auiDialog.fail('结束日期不能大于今天。');
                        return false;
                    }
                    if (dateNum && AUI.DateUtil.calDaysDual(endTime, startTime) > dateNum) {
                        auiDialog.fail('时间跨度不能超过' + dateNum + '天。');
                        return false;
                    }
                    return true;
                }

                function checkQueryMonth(startTime, endTime, monthNum) {
                    startTime = dateToString(startTime);
                    endTime = dateToString(endTime);
                    try {
                        var dateArr = startTime.split("-");
                        var checkDate = new Date();
                        checkDate.setFullYear(dateArr[0], dateArr[1] - 1 + monthNum, dateArr[2]);
                        var checkTime1 = checkDate.getTime();

                        var dateArr2 = endTime.split("-");
                        var checkDate2 = new Date();
                        checkDate2.setFullYear(dateArr2[0], dateArr2[1] - 1, dateArr2[2]);
                        var checkTime2 = checkDate2.getTime();

                        if ((checkTime1 - checkTime2) < 0) {
                            auiDialog.fail('时间跨度不能超过' + monthNum + '个月。');
                            return false;
                        }
                    } catch (e) {
                        return false;
                    }
                    return true;
                }

                return {
                    getQuerySumDate: getQuerySumDate,
                    ration: ration,
                    getXAxis: getXAxis,
                    checkQueryDate: checkQueryDate,
                    checkQueryMonth: checkQueryMonth,
                    initInstallConf: initInstallConf,
                    initActivateConf: initActivateConf,
                    initActiveConf: initActiveConf,
                    initActivationConf: initActivationConf
                };
            }
        ]
    )
    ;
})
;
